import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './css/visitorAccess.scss';
import { QRCode } from 'react-qrcode-logo';
import HomePageImagePortrait from '../../../../assets/images/vms/lp_portrait.png';
import HomePageImageLandscape from '../../../../assets/images/vms/lp_landscape.png';
import HomePageLogo from '../../../../assets/images/vms/bslogo.png';
import CheckinLogo from '../../../../assets/svg/vms/checkin.svg';
import CheckoutLogo from '../../../../assets/svg/vms/checkout.svg';

class VisitorAccess extends Component {
  // eslint-disable-next-line class-methods-use-this
  goToCheckIn() {
    const { history } = this.props;
    history.push({ pathname: '/visitor-checkin', state: { from: '/visitor' } });
  }

  // eslint-disable-next-line class-methods-use-this
  goToCheckOut() {
    const { history } = this.props;
    history.push({ pathname: '/visitor-checkout', state: { from: '/visitor' } });
  }

  render() {
    const { translations } = this.props;

    return (
      <>
        <div className="lp-wrap">
          <div className="lp-wrap__left">
            <div className="lp-wrap__left-image">
              <img className="hide__portrait" src={HomePageImagePortrait} alt="homepage-img" />
              <img className="hide__landscape" src={HomePageImageLandscape} alt="homepage-img" />
            </div>
          </div>
          <div className="lp-wrap__right">
            <div className="lp-wrap__head">
              <div className="lp-wrap__head-logo" onClick={() => window.location.reload(true)}>
                <img src={HomePageLogo} alt="homepage-logo" />
              </div>
              <div className="lp-wrap__head-title">
                {_.replace(_.get(translations, 'welcomeTo'), ':officeName', window.__env.visitorAccessOfficeName)}!
              </div>
            </div>
            <div className="lp-boxes">
              <div className="lp-boxes__row">
                <div className="lp-boxes__box" onClick={() => this.goToCheckIn()}>
                  <img src={CheckinLogo} alt="checkin" />
                  <div className="lp-boxes__box-text-checkin">{_.get(translations, 'checkInViaCurrentDevice')}</div>
                </div>
                <div className="lp-boxes__box">
                  <div className="lp-qr-code">
                    <QRCode value={`${window.location.host}/visitor-checkin`} size={88} />
                  </div>
                  <div className="lp-boxes__box-text">{_.get(translations, 'checkInWithYourMobilePhone')}</div>
                </div>
              </div>
              <>
                <div className="lp-boxes__box lp-boxes__box-full" onClick={() => this.goToCheckOut()}>
                  <img src={CheckoutLogo} alt="checkout" />
                  <div className="lp-boxes__box-text">{_.get(translations, 'checkoutBeforeYouGo')}</div>
                </div>
              </>
            </div>
            <div className="lp-wrap__mobile">
              <img className="show__mobile" src={HomePageImagePortrait} alt="homepage-img" />
            </div>
          </div>
        </div>
        <div className="lp-footer">{_.get(translations, 'allRightsReserved')}</div>
      </>
    );
  }
}

export default withRouter(VisitorAccess);

VisitorAccess.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  translations: PropTypes.shape().isRequired,
};
